/* JB'S theme interactions */
(function(){
  var $=function(s,r){return (r||document).querySelector(s)},$$=function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))};
  function money(c){return (window.JBS_FMT||'${{amount}}').replace(/\{\{\s*amount\s*\}\}/,(c/100).toFixed(2)).replace(/\{\{\s*amount_no_decimals\s*\}\}/,Math.round(c/100))}
  window.jbsMoney=money;

  // nav
  var nb=$('[data-nav-btn]'),nav=$('[data-nav]');
  if(nb&&nav)nb.addEventListener('click',function(){nav.classList.toggle('on')});

  // Black Friday countdown (hides itself when the window closes)
  var top=$('[data-bf-end]');
  if(top){
    var end=new Date(top.getAttribute('data-bf-end')).getTime(),clk=$('[data-bf-clock]');
    var pad=function(n){return String(n).padStart(2,'0')};
    (function tick(){
      var ms=end-Date.now();
      if(!(ms>0)){top.classList.add('bf-over');return}
      var s=Math.floor(ms/1000);
      $('[data-d]',clk).textContent=pad(Math.floor(s/86400));$('[data-h]',clk).textContent=pad(Math.floor(s%86400/3600));
      $('[data-m]',clk).textContent=pad(Math.floor(s%3600/60));$('[data-s]',clk).textContent=pad(s%60);
      setTimeout(tick,1000-(Date.now()%1000));
    })();
  }

  // reveal
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}})},{rootMargin:'0px 0px -8% 0px'});
    $$('.reveal').forEach(function(r){io.observe(r)});
  } else $$('.reveal').forEach(function(r){r.classList.add('in')});

  // gallery
  $$('[data-gal]').forEach(function(g){
    var slides=$('.slides',g),n=slides.children.length,cur=0,t,prog=$$('.prog i',g.parentNode),cnt=$('.count',g);
    function go(i){cur=(i+n)%n;slides.style.transform='translateX(-'+cur*100+'%)';
      if(cnt)cnt.textContent=String(cur+1).padStart(2,'0')+' / '+String(n).padStart(2,'0');
      prog.forEach(function(b,k){b.className=k<cur?'done':''});if(prog[cur]){void prog[cur].offsetWidth;prog[cur].className='on'}
      clearTimeout(t);t=setTimeout(function(){go(cur+1)},4500)}
    var sx=0,sy=0;
    g.addEventListener('touchstart',function(e){sx=e.touches[0].clientX;sy=e.touches[0].clientY},{passive:true});
    g.addEventListener('touchend',function(e){var dx=e.changedTouches[0].clientX-sx,dy=e.changedTouches[0].clientY-sy;if(Math.abs(dx)>40&&Math.abs(dx)>Math.abs(dy))go(cur+(dx<0?1:-1))});
    g.addEventListener('click',function(e){var r=g.getBoundingClientRect();go(cur+(e.clientX-r.left>r.width/2?1:-1))});
    $$('[data-go]').forEach(function(b){b.addEventListener('click',function(){$$('[data-go]').forEach(function(x){x.classList.remove('on')});b.classList.add('on');go(+b.dataset.go)})});
    go(0);
  });

  // bundle cards
  var form=$('[data-jbs-form]');
  if(form){
    var cards=$$('.card',form),idIn=$('[name=id]',form),btn=$('[data-buy]',form),btnP=$('[data-btn-price]',form),per=$('[data-per]'),bar=$('[data-bar]'),save=$('[data-save]'),
        st=$('[data-sticky]'),stN=$('[data-st-name]'),stB=$('[data-st-btn]'),stI=$('[data-st-img]');
    var shown=0;
    function anim(to){var from=shown,t0=performance.now();(function f(t){var k=Math.min(1,(t-t0)/450),v=from+(to-from)*(1-Math.pow(1-k,3));btnP.textContent=money(Math.round(v));if(k<1)requestAnimationFrame(f)})(t0);shown=to}
    function pick(c){
      cards.forEach(function(x){x.classList.toggle('sel',x===c);x.setAttribute('aria-checked',x===c)});
      $$('.perk',form).forEach(function(p){p.classList.toggle('on',p.dataset.for===c.dataset.id)});
      var p=+c.dataset.price,cmp=+c.dataset.compare,q=+c.dataset.qty||1;
      idIn.value=c.dataset.id;anim(p);
      if(per)per.textContent=money(Math.round(p/q))+' / pouch';
      var s=cmp>p?cmp-p:0;
      if(bar)bar.style.width=(cmp?Math.min(100,s/cmp*160):0)+'%';
      if(save)save.textContent=s?money(s)+' · '+Math.round(s/cmp*100)+'%':'—';
      if(stN)stN.textContent=c.dataset.title;if(stB)stB.textContent='Add · '+money(p);if(stI)stI.src=c.dataset.img;
      if(history.replaceState){var u=new URL(location.href);u.searchParams.set('variant',c.dataset.id);history.replaceState(null,'',u)}
    }
    cards.forEach(function(c){c.addEventListener('click',function(){pick(c)})});
    pick($('.card.sel',form)||cards[0]);
    function add(){
      btn.disabled=true;if(stB)stB.disabled=true;
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:+idIn.value,quantity:1}]})})
      .then(function(r){if(!r.ok)throw r;return r.json()}).then(function(){location.href='/cart'})
      .catch(function(){btn.disabled=false;if(stB)stB.disabled=false;form.submit()});
    }
    form.addEventListener('submit',function(e){e.preventDefault();add()});
    if(stB)stB.addEventListener('click',add);
    if(st)st.classList.add('on');
  }

  // cart
  var cart=$('[data-cart]');
  if(cart){
    function change(line,q){cart.style.opacity=.55;fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({line:line,quantity:q})}).then(function(){location.reload()})}
    $$('[data-q]',cart).forEach(function(b){b.addEventListener('click',function(){change(+b.dataset.line,+b.dataset.q)})});
    $$('[data-upgrade]',cart).forEach(function(b){b.addEventListener('click',function(){
      b.disabled=true;cart.style.opacity=.55;
      fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({line:+b.dataset.line,quantity:0})})
      .then(function(){return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:+b.dataset.upgrade,quantity:1}]})})})
      .then(function(){location.reload()})})});
  }
})();
